import axios from 'axios';
import type { 
  Position, 
  PositionQueryParams, 
  PositionSearchParams 
} from '@/types/position';
import { getApiUrl } from '@/config/config';

// 硬编码API URL，使用域名而不是IP
const API_URL = 'https://aivitahelper.xyz:8081/api/positions';

export const positionService = {
  // 创建职位
  createPosition: async (position: Position) => {
    const response = await axios.post(API_URL, position);
    return response.data;
  },

  // 更新职位
  updatePosition: async (position: Position) => {
    if (!position.id) {
      throw new Error('职位ID不能为空');
    }
    const response = await axios.put(`${API_URL}/${position.id}`, position);
    return response.data;
  },

  // 删除职位
  deletePosition: async (id: number) => {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  },

  // 获取单个职位详情
  getPosition: async (id: number) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },

  // 根据公司ID获取职位列表
  getPositionsByCompany: async (companyId: number, page = 1, size = 10) => {
    const response = await axios.get(`${API_URL}/company/${companyId}`, {
      params: { page, size }
    });
    return response.data;
  },

  // 条件查询职位
  queryPositions: async (params: PositionQueryParams) => {
    const response = await axios.get(API_URL, { params });
    return response.data;
  },

  // 关键字搜索职位
  searchPositions: async (params: PositionSearchParams) => {
    const response = await axios.get(`${API_URL}/search`, { params });
    return response.data;
  }
}; 